/* eslint-disable default-case */
import produce from 'immer'
import { combineReducers } from 'redux'
import {
  HINDSIGHT_ADD_SUCCESS,
  HINDSIGHT_DELETE_SUCCESS,
  HINDSIGHT_FETCH_FAILURE,
  HINDSIGHT_FETCH_START,
  HINDSIGHT_FETCH_SUCCESS,
  HINDSIGHT_SINGLE_FETCH_SUCCESS,
  HINDSIGHT_UPDATE_SUCCESS,
} from '../action/constants'

const initialState = {
  byIds: {},
  hindsight: {
    loading: false,
    data: [],
    totalPages: 0,
  },
}

const idsReducer = produce((draft, action) => {
  switch (action.type) {
    case HINDSIGHT_FETCH_SUCCESS:
      ;(action.payload.payload || []).forEach((item) => {
        draft[item._id] = item
      })
      break
    case HINDSIGHT_ADD_SUCCESS:
      draft[action.payload._id] = action.payload
      break
    case HINDSIGHT_DELETE_SUCCESS:
      delete draft[action.payload]
      break
    case HINDSIGHT_UPDATE_SUCCESS:
      draft[action.payload._id] = { ...draft[action.payload._id], ...action.payload }
      break
    case HINDSIGHT_SINGLE_FETCH_SUCCESS:
      draft[action.payload._id] = action.payload
      break
  }
}, initialState.byIds)

const hindsightSubReducer = produce((draft, action) => {
  switch (action.type) {
    case HINDSIGHT_FETCH_START:
      draft.loading = true
      break
    case HINDSIGHT_FETCH_SUCCESS:
      draft.loading = false
      draft.data = (action.payload.payload || []).map((item) => item._id)
      draft.totalPages = action.payload.maxCount
        ? Math.ceil(action.payload.currCount / action.payload.maxCount)
        : 0
      break
    case HINDSIGHT_FETCH_FAILURE:
      draft.loading = false
      break
    case HINDSIGHT_ADD_SUCCESS:
      draft.data.unshift(action.payload._id)
      break
    case HINDSIGHT_DELETE_SUCCESS: {
      const index = draft.data.indexOf(action.payload)
      if (index > -1) {
        draft.data.splice(index, 1)
      }
      break
    }
  }
}, initialState.hindsight)

const hindsightReducer = combineReducers({
  byIds: idsReducer,
  hindsight: hindsightSubReducer,
})

export default hindsightReducer
